export async function sendInvite(data) {
  const {
    to,
    name,
    eventTitle,
    passphrase,
    vrc,
    moderatorContact,
    link,
  } = data;

  const endpoint = process.env.REACT_APP_FUNCTION_URL;
  const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

  // 👇 NEW DEBUG LOGS
  if (!endpoint) console.error("🚨 Missing endpoint env var!");
  if (!anonKey) console.error("🚨 Missing anonKey env var!");

  console.log("📤 Calling:", endpoint);
  console.log("🔑 Using key:", anonKey ? "✔️ present" : "❌ MISSING");
  console.log("📦 Payload:", data);

  if (!endpoint || !anonKey) {
    throw new Error("❌ Missing REACT_APP_FUNCTION_URL or REACT_APP_SUPABASE_ANON_KEY in .env");
  }

  const res = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${anonKey}`,
    },
    body: JSON.stringify({
      to,
      name,
      eventTitle,
      passphrase,
      vrc,
      moderatorContact,
      link,
    }),
  });

  const text = await res.text();

  console.log("📡 Response status:", res.status);
  console.log("📡 Response text:", text);

  if (!res.ok) {
    throw new Error(`❌ Email failed: ${text}`);
  }

  return text;
}
